import { WithRef } from '../../../types';
import IconBase, { CastProductIconProps } from '../IconBase';

const DEFAULT_PRESET_BACKGROUND = '#FF521D';

export const CastKimchi = ({
  ref,
  variant,
  color = 'currentColor',
  ...props
}: WithRef<SVGSVGElement, CastProductIconProps>) => {
  const isPreset = variant === 'preset';
  const fill = isPreset
    ? props.fill ?? DEFAULT_PRESET_BACKGROUND
    : props.fill ?? 'none';
  const iconColor = isPreset ? '#FFFFFF' : color;

  return (
    <IconBase
      ref={ref}
      {...props}
      color={color}
      viewBox="0 0 104 104"
      fill="none"
    >
      <circle cx="52" cy="52" r="52" fill={fill} />
      <path
        d="M68.4453 24.9434C69.8633 24.1758 71.6465 23.7174 73.4815 24.2159C73.8272 24.2962 74.1333 24.3912 74.4356 24.502L75.918 25.046L75.5098 26.5723C75.3463 27.1823 75.2014 27.7225 75.0381 28.3321L74.6436 29.8038L73.1348 29.5967C73.0236 29.5815 72.924 29.5749 72.8076 29.5743C72.2468 29.5861 71.7536 29.864 71.2656 30.6768C70.8877 31.3065 70.5933 32.1481 70.3809 33.1075C74.8704 36.0326 77.8438 41.099 77.8438 46.8633C77.8437 49.5288 77.2065 52.0501 76.0752 54.2794C71.5101 64.3991 54.1776 84.8811 23.4649 79.0079C21.8791 78.7044 20.9912 77.4161 20.9014 76.1241C20.8134 74.8556 21.4784 73.4866 22.8975 72.8809C31.0692 69.3935 35.5878 65.7087 38.5977 61.2325C41.6546 56.6862 43.26 51.1903 45.3281 43.7247C46.7936 36.1641 53.4456 30.4543 61.4356 30.4542L61.8828 30.46C62.4393 30.4751 62.9888 30.5196 63.5303 30.5889C63.951 29.7293 64.4417 28.886 65.0205 28.0655L65.1738 27.8419C65.9617 26.7306 67.1102 25.6663 68.4453 24.9434Z"
        fill={iconColor}
      />
    </IconBase>
  );
};

CastKimchi.displayName = 'CastKimchi';
